export default __webpack_public_path__ + "static/media/rnr-sports-table-18-cn.3f40bf4e.webp";